import { useEffect, useRef, useState } from 'react';
import { useChannels, useChatMessageSocketSendEvents, useFlightRooms, useSocket } from '@connect-x-app/hybrid-state';

export const useWindowFocus = () => {
  const [isFocused, setIsFocused] = useState(true);
  const { connectSocket } = useSocket();
  const { selectedChannel } = useChannels();
  const { selectedFlightRoom } = useFlightRooms();
  const { sendChatReadAllMessages } = useChatMessageSocketSendEvents();
  const hasLostFocusRef = useRef(false);

  useEffect(() => {
    const handleFocus = () => {
      setIsFocused(true);
    };

    const handleBlur = () => {
      setIsFocused(false);
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        setIsFocused(true);
      } else {
        setIsFocused(false);
      }
    };

    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    if (isFocused) {
      connectSocket();
    }
  }, [connectSocket, isFocused]);

  useEffect(() => {
    if (!isFocused) {
      hasLostFocusRef.current = true;
      return;
    }
    if (!hasLostFocusRef.current) {
      return;
    }
    hasLostFocusRef.current = false;
    if (selectedChannel?.id && selectedFlightRoom?.id) {
      sendChatReadAllMessages({ channelId: selectedChannel.id, chatroomId: selectedFlightRoom.id });
    }
  }, [isFocused, selectedChannel?.id, selectedFlightRoom?.id, sendChatReadAllMessages]);
};
